import { PJ } from "app/shared/data/pj";

export class PJDTO {  

    constructor (
        private idPJ: number,
        private filenameOrg: String,
        private longitude: number,
        private latitude: number,
        private altitude: number,
        private content: String
        // cdate, mdate
    ) {
        
    }

    static build(pj: PJ): PJDTO {
        return new PJDTO(pj.id, null, pj.longitude, pj.latitude, pj.altitude, pj.content);
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/services/data/PJDTO.ts